module.exports = __webpack_public_path__ + "assets/1ad2c80c8378714119d85151c7058a18.png";